import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PartnersContainer from "./PartnersContainer";

const InsuredClientContainer = ({
  documentId,
  insuredId,
  clientId,
  financingType,
  insuranceTypeId,
  loaded,
  globalReadOnly,
  dirtyInfoRef,
  setDirtyInfoRef
}) => {
  const [partners, setPartners] = useState({ insuredId: null, clientId: null });

  useEffect(() => {
    setPartners({ insuredId: insuredId, clientId: clientId });
  }, [insuredId, clientId, setPartners]);

  return (
    <>
      {loaded && (
        <PartnersContainer
          partners={partners}
          documentId={documentId}
          financingType={financingType}
          insuranceTypeId={insuranceTypeId}
          globalReadOnly={globalReadOnly}
          dirtyInfoRef={dirtyInfoRef}
          setDirtyInfoRef={setDirtyInfoRef}
        />
      )}
    </>
  );
};

InsuredClientContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  insuredId: PropTypes.number,
  clientId: PropTypes.number,
  financingType: PropTypes.string,
  insuranceTypeId: PropTypes.number,
  loaded: PropTypes.bool,
  globalReadOnly: PropTypes.func.isRequired,
  dirtyInfoRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]).isRequired,
  setDirtyInfoRef: PropTypes.func.isRequired
};

export default InsuredClientContainer;
